module Meevo.Plugins.Register {
    "use strict";

    export class PackageSection extends Meevo.Plugins.Register.RegisterSectionBase {

        get $rootScope() { return this.registerContext.$rootScope; }
        get $q() { return this.registerContext.$q; }
        get $translate() { return this.registerContext.$translate; }

        get endPoints() { return this.registerContext.appSettings.API_ENDPOINTS; }
        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get roundingService() { return this.registerContext.roundingService; }
        get securityService() { return this.registerContext.securityService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.Package, registerContext, "package", Register.RegisterSectionCatTypeEnum.Sale);

            this.transactionSaleLines = new Components.BaseClasses.PagedResults<Model.SaleLine, any>(this.dataService, "ClientPackageHistory", this.onSearch);

            this.securityService.checkSecurityKey(this.securityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.canViewStudentTeacherModule = result === Meevo.Model.SecurityAccessEnum.Grant;
            });
        }

        readonly clientPackageServiceUsed: string = 'clientPackageServiceUsed';
        readonly clientPackageProductUsed: string = 'clientPackageProductUsed';
        readonly packageProduct: string = 'packageProduct';
        readonly packageService: string = 'packageService';

        packageTypeListItem: any;
        packageType: Model.PackageType;
        packageSale: any;
        saleLine: Model.SaleLine;
        minStartDate: Date = moment().toDate();
        autoGenerateClientPackageNumber: boolean;
        originalClientPackageNumber: string;
        packageTypes: any;
        scannedTransactionId: string = "";
        showRefundPackageDetails: boolean = false;
        prepaidTipAmount: number;
        filter: string = '';
        minServiceFilterLength: number = 2;
        isExpanded: boolean = false;
        taxRates: any[] = [];
        // --- SALE ---

        createYourOwnListItem: any;

        selectedReferredByEnum: Meevo.Model.ReferredByEnum;
        selectedReferredByDetail: Meevo.Model.ReferralDetail;
        securityKeys = Meevo.Components.Common.SecurityKeys;
        canViewStudentTeacherModule: boolean = false;
        globalTypeaheadCriteria: any = { isGlobal: true };
        packageCreationType = Meevo.Model.PackageCreationTypeEnum;

        // --- REFUND ---
        allowedUnlimitedItemTypes = [Model.PackageItemTypeEnum.Service];

        isProductUsageTrackingPackage(): boolean {
            return this.packageSale && (this.packageSale.category === Model.PackageTypeCategoryEnum.ProductUsageTracking || _(this.packageSale.packageProductUnits).any());
        }

        isStandardPackage(): boolean {
            return this.packageSale && (this.packageSale.category === Model.PackageTypeCategoryEnum.Standard || _(this.packageSale.packageServices).any() || _(this.packageSale.packageProducts).any());
        }

        getPackageTypes() {
            let request: any = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    isMembershipOnly: false,
                    filter: this.filter.trim().length >= this.minServiceFilterLength ? this.filter : '',
                    hasProductUnits: this.registerContext.isProductUsageTrackingEnabled ? null : 0
                }
            }

            return this.dataService.getListPaged(this.endPoints.packageType, request).then((response: any) => {
                this.packageTypes = response;
            });
        }

        getPackagesDebounce = _.debounce(() => {
            this.$rootScope.$apply(() => {
                this.getPackageTypes();
            });
        }, 300);

        filterChange() {
            this.getPackagesDebounce();
        }

        add(packageTypeListItem) {
            this.registerContext.hideCheckoutButtons = true;
            this.packageSale = {
                client: this.registerContext.selectedClient,
                startDate: moment().toDate(),
                isCustom: packageTypeListItem.packageCreationType === Meevo.Model.PackageCreationTypeEnum.Custom,
                packageCreationType: packageTypeListItem.packageCreationType || Meevo.Model.PackageCreationTypeEnum.Predefined,
            };

            this.packageTypeListItem = packageTypeListItem;

            this.taxRates = [];
            if (!this.packageTypeListItem.id) {
                this.packageSale.packageServices = new Array<Model.PackageTypeService>();
                this.packageSale.packageProducts = new Array<Model.PackageTypeProduct>();
                this.packageSale.packageProductUnits = new Array<Model.PackageTypeProductUnit>();
                this.packageSale.prepaidTip = this.packageSale.price = this.packageSale.packageChargeAmount = 0;
                this.packageSale.isUnlimitedServices = false;
            } else {
                this.dataService.getItem(this.endPoints.packageType, this.packageTypeListItem.id)
                    .then((response: Model.PackageType) => {
                        this.packageType = response;
                        this.packageSale.price = response.packagePrice;
                        this.packageSale.prepaidTip = response.defaultPrepaidTip || 0;
                        this.loadCustomizablePackageSaleDetails();
                        this.packageSale.isMembershipOnly = response.isMembershipOnly;
                        this.packageSale.originalPackagePrice = response.packagePrice;
                        this.setEndDate();
                        var taxItemGet = {
                            taxItemType: Model.TaxItemTypeEnum[Model.TaxItemTypeEnum.Service]
                        };
                        if (!response.isTaxExempted && response.packageChargeAmount > 0) {
                            this.dataService.customMethodData("/api/Tax/TaxItemList/", "POST", taxItemGet).then((responseTaxItemList: any) => {
                                let taxItemList = responseTaxItemList.data;
                                if (response.taxItem_LId) {
                                    let taxItem = _(taxItemList).findWhere({ id: response.taxItem_LId })
                                    if (taxItem) {
                                        this.taxRates = taxItem.taxItemRates;
                                    }
                                    else {
                                        this.taxRates = _(taxItemList).findWhere({ isDefault: true }).taxItemRates;
                                    }
                                }
                                else if (taxItemList.length === 1) {
                                    this.taxRates = taxItemList[0].taxItemRates;
                                }
                            });
                        }
                    });
            }
        }

        setEndDate() {
            if (this.packageType.expireAfterPurchaseWeeks > 0) {
                this.packageSale.endDate = moment(this.packageSale.startDate).add("weeks", this.packageType.expireAfterPurchaseWeeks).toDate();
            }
            else if (this.packageSale.endDate && this.packageSale.endDate < this.packageSale.startDate) {
                this.packageSale.endDate = this.packageSale.startDate;
            }
        }

        canCustomize() {
            return this.isPredefinedPackage();
        }

        private loadServices(packageTypeServices: Model.PackageTypeService[]) {
            let packageServices = [];
            packageTypeServices.forEach((packageService: Model.PackageTypeService) => {
                packageServices.push({
                    service: {
                        id: packageService.id,
                        displayName: packageService.displayName,
                        shortcut: packageService.shortcut,
                        doNotAllowTips: packageService.doNotAllowTips
                    },
                    serviceId: packageService.id,
                    valueEach: packageService.fullItemPrice,
                    quantity: packageService.quantity,
                    fullItemPrice: packageService.fullItemPrice
                });
            });
            this.packageSale.packageServices = packageServices;
            this.updateServiceCriteria();
        }

        private loadProducts(packageTypeProducts: Model.PackageTypeProduct[]) {
            let packageProducts = [];
            packageTypeProducts.forEach((packageProduct: Model.PackageTypeProduct) => {
                packageProducts.push({
                    product: {
                        id: packageProduct.id,
                        displayName: packageProduct.displayName
                    },
                    productVariantId: packageProduct.id,
                    valueEach: packageProduct.fullItemPrice,
                    quantity: packageProduct.quantity,
                    fullItemPrice: packageProduct.fullItemPrice
                });
            });
            this.packageSale.packageProducts = packageProducts;
            this.updateProductCriteria();
        }

        private loadProductUnits(packageTypeProductUnits: Model.PackageTypeProductUnit[]) {
            let packageProductUnits = [];
            packageTypeProductUnits.forEach((packageProductUnit: Model.PackageTypeProductUnit) => {
                packageProductUnits.push({
                    productUnit: {
                        id: packageProductUnit.id,
                        displayName: packageProductUnit.displayName
                    },
                    productVariantId: packageProductUnit.id,
                    valueEach: packageProductUnit.fullItemPrice,
                    quantity: packageProductUnit.quantity,
                    fullItemPrice: packageProductUnit.fullItemPrice,
                    productUsageType: packageProductUnit.productUsageType
                });
            });
            this.packageSale.packageProductUnits = packageProductUnits;
            this.updateProductUnitCriteria();
        }

        serviceCriteria: any;
        updateServiceCriteria() {
            this.serviceCriteria.excludeIdList = _.pluck(this.packageSale.packageServices, "serviceId");
        }

        productCriteria: any;
        updateProductCriteria() {
            this.productCriteria.excludeIdList = _.pluck(this.packageSale.packageProducts, "productVariantId");
        }

        productUnitCriteria: any;
        updateProductUnitCriteria() {
            this.productUnitCriteria.excludeIdList = _.pluck(this.packageSale.packageProductUnits, "productVariantId");
        }

        serviceChanged(packageService) {
            packageService.serviceId = !packageService.service ? undefined : packageService.service.id;
            if (packageService.service != undefined) {
                this.getServicePrice(packageService);
            }
            this.updateServiceCriteria();
        }

        productChanged(packageProduct) {
            packageProduct.productVariantId = !packageProduct.product ? undefined : packageProduct.product.id;
            if (packageProduct.product != undefined) {
                packageProduct.price = packageProduct.fullItemPrice = packageProduct.valueEach = packageProduct.product.fullItemPrice;
            }
            this.updateProductCriteria();
        }

        productUnitChanged(packageProductUnit) {
            packageProductUnit.productVariantId = !packageProductUnit.productUnit ? undefined : packageProductUnit.productUnit.id;
            if (!!packageProductUnit.productUnit && !!packageProductUnit.productUnit.productId) {
                this.dataService.customMethodData(`/api/product/${packageProductUnit.productUnit.productId}/Usage`, "GET", {}).then((response) => {
                    const settings = response.data.variantUsageSettings || [];
                    const variantSetting = settings.find(setting => setting.id === packageProductUnit.productVariantId);

                    let chargeAmount = !variantSetting || variantSetting.chargeType === Model.ProductVariantChargeTypeEnum.None ? 0 :
                        variantSetting.chargeAmount;
                    packageProductUnit.price = packageProductUnit.fullItemPrice = packageProductUnit.valueEach = chargeAmount;
                    packageProductUnit.productUsageType = packageProductUnit.productUnit.productUsageType;
                })
            }
            this.updateProductUnitCriteria();
        }

        getServicePrice(packageService) {
            this.dataService.customMethodData(`/api/service/${packageService.service.id}/price`, 'GET', null)
                .then(response => {
                    packageService.price = response.data;
                    packageService.fullItemPrice = response.data;
                    packageService.valueEach = response.data;
                });
        }

        loadCustomizablePackageSaleDetails() {
            this.packageSale.isUnlimitedServices = this.packageType.isUnlimitedServices;
            this.packageSale.isFullCommissionRedemption = this.packageType.isFullCommissionRedemption;
            this.packageSale.isShareable = this.packageType.isShareable;
            this.packageSale.isSplitSwapable = this.packageType.isSplitSwappable;
            this.packageSale.packageChargeAmount = this.packageType.packageChargeAmount;
            this.packageSale.isPackageChargePercent = this.packageType.isPackageChargePercent;
            this.loadServices(this.packageType.services);
            this.loadProducts(this.packageType.products);
            this.loadProductUnits(this.packageType.productUnits);
        }

        isCustomChanged() {
            if (!this.packageSale.isCustom) {
                this.packageSale.packageCreationType = Meevo.Model.PackageCreationTypeEnum.Predefined;
                this.packageSale.price = this.packageType.packagePrice;
                this.loadCustomizablePackageSaleDetails();
            } else {
                this.packageSale.packageCreationType = Meevo.Model.PackageCreationTypeEnum.Custom;
            }
        }

        unlimitedServicesChanged(){
            if(!this.packageSale.isUnlimitedServices)
            {
                return;
            }

            this.packageSale.price = null;
            this.packageSale.prepaidTip = 0;
            this.packageSale.packageServices.forEach(service => {
                service.quantity = 1;
            });
        }

        isPredefinedPackage() {
            return this.packageTypeListItem && this.packageTypeListItem.id;
        }

        isCustomPackage() {
            return (this.packageSale && this.packageSale.isCustom) || !this.isPredefinedPackage();
        }

        addItem(existingItems) {
            existingItems.push({ quantity: 1, valueEach: 0 });
        }

        deleteService(index) {
            this.packageSale.packageServices.splice(index, 1);
            if (this.packageSale.packageServices.length < 1) {
                this.packageSale.isUnlimitedServices = false;
                this.packageSale.isSplitSwapable = false;
                this.packageSale.prepaidTip = 0;
                this.packageSale.packageChargeAmount = 0;
            }
            this.updateServiceCriteria();
        }

        deleteProduct(index) {
            this.packageSale.packageProducts.splice(index, 1);
            this.updateProductCriteria();
        }

        deleteProductUnit(index) {
            this.packageSale.packageProductUnits.splice(index, 1);
            this.updateProductUnitCriteria();
        }

        startDateChanged() {
            this.setEndDate();
        }

        save(isValid) {
            if (!isValid || !this.packageHasMinimumItems()) {
                return;
            }

            this.validateClientPackageNumber().then((response) => {
                if (!response) {
                    return;
                }

                this.packageSale.price = this.getPackagePrice();
                this.packageSale.clientId = this.packageSale.client.id;
                this.packageSale.packageTypeId = this.packageTypeListItem.id;
                if (this.packageSale.id) {
                    let clone = jQuery.extend(true, {}, this.saleLine);
                    this.saleLine.isDirty = true;
                    for (const packageService of this.packageSale.packageServices) {
                        packageService.prepaidTip = undefined;
                    }
                    (<Register.PackageSaleLineItem>this.saleLine.item).clientPackage = this.packageSale;
                    this.saleLine.baseItemPrice = this.packageSale.price;
                    this.saleLine.finalItemPrice = this.packageSale.price;
                    this.saleLine.prepaidTip = this.packageSale.prepaidTip;
                    this.saleLine.referredByDetail = this.selectedReferredByDetail;
                    this.registerContext.recalculateSale()
                        .then(() => {
                            this.reset();
                        })
                        .catch(() => {
                            this.saleLine.isDirty = false;
                            this.saleLine.item = clone.item;
                            this.saleLine.baseItemPrice = clone.baseItemPrice;
                            this.saleLine.finalItemPrice = clone.finalItemPrice;
                            this.saleLine.prepaidTip = (<Register.PackageSaleLineItem>clone.item).clientPackage.prepaidTip;
                        });
                } else {
                    this.addSaleLine();
                }
            });
        }

        validateClientPackageNumber(): ng.IPromise<boolean> {
            let deferred = this.$q.defer<boolean>();

            if (this.autoGenerateClientPackageNumber) {
                this.packageSale.clientPackageNumber = '';
                deferred.resolve(true);
            } else {
                if (this.packageSale.clientPackageNumber == undefined || this.packageSale.clientPackageNumber.trim().length === 0) {
                    this.modalService.okCancelHandler("MESSAGE_PACKAGE_NUMBER_GENERATE")
                        .then((response) => {
                            deferred.resolve(response);
                        });
                } else {
                    deferred.resolve(true);
                }
            }
            return deferred.promise;
        }

        edit(saleLine: Model.SaleLine) {
            this.registerContext.hideCheckoutButtons = true;
            this.saleLine = saleLine;

            if (this.saleLine.isRefund) {
                let item = <Register.PackageSaleLineItem>saleLine.item;
                this.packageNumber = item.clientPackage.clientPackageNumber;
                this.refundPackageNumberChange();
                return;
            }

            this.dataService.getItem("clientpackage", new Guid(saleLine.item.id)).then((response: any) => {
                response.price = saleLine.baseItemPrice;
                response.prepaidTip = saleLine.prepaidTip;

                if (response.packageTypeId) {
                    this.packageTypeListItem = {
                        id: response.packageTypeId,
                        displayName: response.packageTypeDisplayName
                    }
                } else {
                    this.packageTypeListItem = this.createYourOwnListItem;
                }

                response.client = {
                    id: response.clientId,
                    firstName: response.clientFirstName,
                    lastName: response.clientLastName,
                    displayName: response.clientLastName + ", " + response.clientFirstName,
                    primaryPhoneNumber: response.clientPhoneNumber
                }

                response.packageServices.forEach((packageService: any) => {
                    packageService.service = {
                        id: packageService.serviceId,
                        displayName: packageService.serviceDisplayName,
                        shortcut: packageService.serviceShortcut
                    }
                });

                response.packageProducts.forEach((packageProduct: any) => {
                    packageProduct.product = {
                        id: packageProduct.productVariantId,
                        displayName: packageProduct.productVariantDisplayName,
                    }
                })

                response.packageProductUnits.forEach((packageProductUnit: any) => {
                    packageProductUnit.productUnit = {
                        id: packageProductUnit.productVariantId,
                        displayName: packageProductUnit.productVariantDisplayName,
                    }
                })

                this.packageSale = response;
                this.packageSale.isCustom = (response.packageCreationType !== Meevo.Model.PackageCreationTypeEnum.Predefined);
                this.packageSale.isFullCommissionRedemption = (<Meevo.Plugins.Register.PackageSaleLineItem> saleLine.item).clientPackage.isFullCommissionRedemption

                // because package charge isn't stamped on client package, have to pull it out of the saleline
                const packageCharge = _(saleLine.charges).find(charge => charge.chargeType === Meevo.Model.ChargeTypeEnum.PackageFee);
                if (packageCharge) {
                    this.packageSale.packageChargeAmount = packageCharge.chargeAmount;
                    this.packageSale.isPackageChargePercent = packageCharge.isPercent;
                }

                this.originalClientPackageNumber = response.clientPackageNumber;

                this.selectedReferredByDetail = saleLine.referredByDetail;
                this.selectedReferredByEnum = saleLine.referredByDetail.referredBy;
            });
        }

        private addSaleLine() {
            let packageCreationType = this.packageSale.isCustom
                ? Meevo.Model.PackageCreationTypeEnum.Custom
                : Meevo.Model.PackageCreationTypeEnum.Predefined;

            let displayName = this.packageSale.isCustom
                ? undefined
                : this.packageTypeListItem.displayName;

            let packageSaleLineItem = new Meevo.Plugins.Register.PackageSaleLineItem({
                displayName: displayName,
                packageCreationType: packageCreationType,
                id: this.packageSale.id
            });

            packageSaleLineItem.clientPackage = jQuery.extend(true, {}, this.packageSale);

            let saleLine: Model.SaleLine = {
                item: packageSaleLineItem,
                quantity: 1,
                baseItemPrice: this.packageSale.price,
                finalItemPrice: this.packageSale.price,
                prepaidTip: this.packageSale.prepaidTip,
                client: this.registerContext.selectedClient,
                clientId: this.registerContext.selectedClient ? this.registerContext.selectedClient.id : undefined,
                clientType: this.registerContext.selectedClientType,
                saleType: Model.SalesTypeEnum.Package,
                isDirty: true,
                isNew: this.registerContext.selectedClientType === Model.ClientTypeEnum.Client,
                showPoleMessage: Model.SaleLineStatusEnum.Added,
                referredByDetail: this.selectedReferredByDetail
            };

            this.registerContext.tempSaleLines = [ saleLine ];
            this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
        }

        isDirty() {
            return !this.registerContext.isRefundMode && !angular.isUndefined(this.packageSale) && angular.isUndefined(this.packageSale.id);
        }

        reset() {
            this.createYourOwnListItem = {
                displayName: this.$translate.instant("LABEL_CREATE_CUSTOM_PACKAGE"),
                packageCreationType: Meevo.Model.PackageCreationTypeEnum.Custom,
            };

            if (!this.registerContext.isRefundMode && !this.registerContext.sellPackagePermission) {
                this.registerContext.showEmptySection();
            }
            if (!this.registerContext.isRefundMode) {
                this.registerContext.hideCheckoutButtons = false;
            }

            this.filter = '';

            this.packageSale = undefined;
            this.packageTypeListItem = undefined;
            this.autoGenerateClientPackageNumber = false;
            this.getPackageTypes();

            this.client = null;
            this.packageNumber = '';
            this.clearSearch();
            this.packageSelected = null;
            this.scannedTransactionId = "";
            this.showRefundPackageDetails = false;

            this.selectedReferredByEnum = null;
            this.selectedReferredByDetail = {
                id: null,
                displayName: null,
                referredBy: null
            };

            if (this.registerContext.isRefundMode && this.registerContext.selectedClientType === Model.ClientTypeEnum.Client) {
                this.client = this.registerContext.selectedClient;
                this.refundClientChange();
            }

            this.serviceCriteria = {
                wildcardType: Model.FilterWildcardType.Contains,
                packageServiceRedemption: this.registerContext.isProductUsageTrackingEnabled
                    ? Meevo.Model.PackageServiceRedemptionEnum.Service
                    : null
            };
            this.productCriteria = { wildcardType: Model.FilterWildcardType.Contains };
            this.productUnitCriteria = {
                enableProductUsageTracking: true,
                includeNotForSale: true,
                explicitProductInventoryTypes: [
                    Meevo.Model.ProductInventoryTypeEnum.ShopSupply,
                    Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply
                ],
            };
            this.calculateTotal();
        }

        delete(saleLine) {
            if (this.packageSale && this.packageSale.id === saleLine.item.id) {
                this.reset();
            }
        }

        getPackageTotalPrice() {
            return this.roundingService.addNormalizedNumbers(this.getPackagePriceCharge(), this.packageSale.prepaidTip);
        }

        isPrepaidTipVisible() {
            if (!this.packageSale || !this.packageSale.packageServices || !this.packageSale.packageProductUnits) {
                return false;
            }

            let packageServices = _(this.packageSale.packageServices).filter(packageService => packageService.service && !packageService.service.doNotAllowTips);

            return packageServices.length > 0 || this.packageSale.packageProductUnits.length > 0;
        }

        isProductUnitAddVisible() {
            return this.isCustomPackage() && !this.isStandardPackage() && this.registerContext.isProductUsageTrackingEnabled &&
                !this.packageSale.isShareable;
        }

        useSelectedClient(selectedPackage) {
            if (this.registerContext.selectedClient) {
                selectedPackage.client = this.registerContext.selectedClient;
                selectedPackage.clientId = this.registerContext.selectedClient.id;
                selectedPackage.clientType = this.registerContext.selectedClientType;
            }
        }

        isPackagePriceEnabled() {
            // "predefined package" (no edit)
            // "predefined package w/ unlimited services" (no edit)
            // customized "predefined package" (no package price edit)
            // customized "predefined package w/ unlimited services" (allow package price edit)
            // custom package (from "Create custom package") (no package price edit)
            // custom package (from "Create custom package") + unlimited services (allow package price edit)

            if (!this.packageSale) {
                return false;
            }

            return this.packageSale.isCustom && this.packageSale.isUnlimitedServices;
        }

        get packagePrice() {
            return this.getPackagePrice();
        }

        getPackagePrice() {
            if (!this.packageSale) {
                return 0;
            }

            // "predefined package" (predefined price)
            // "predefined package w/ unlimited services" (predefined price)
            // customized "predefined package" (sum of packages)
            // customized "predefined package w/ unlimited services" (user-entered price)
            // custom package (from "Create custom package") (sum of packages)
            // custom package (from "Create custom package") + unlimited services (user-entered price)

            if (!this.packageSale.isCustom || this.packageSale.isUnlimitedServices) {
                return this.packageSale.price || 0;
            }

            if (!this.packageSale.packageServices) {
                return 0;
            }

            let newPrice = this.getAllPackageItems(this.packageSale)
                .reduce((sum, item) => sum += (item.valueEach * item.quantity), 0);

            return this.registerContext.normalizeDecimalPlaces(newPrice);
        }

        getPackageServicePrice() {
            if (!this.packageSale || !this.packageSale.packageServices) {
                return 0;
            }

            let newPrice = this.packageSale.packageServices
                .reduce((sum, item) => sum += (item.valueEach * item.quantity), 0);

            return this.registerContext.normalizeDecimalPlaces(newPrice);
        }

        getPackageProductPrice() {
            if (!this.packageSale || !this.packageSale.packageProducts) {
                return 0;
            }

            let newPrice = this.packageSale.packageProducts
                .reduce((sum, item) => sum += (item.valueEach * item.quantity), 0);

            return this.registerContext.normalizeDecimalPlaces(newPrice);
        }

        getPackageProductUnitPrice() {
            if (!this.packageSale || !this.packageSale.packageProductUnits) {
                return 0;
            }

            let newPrice = this.packageSale.packageProductUnits
                .reduce((sum, item) => sum += (item.valueEach * item.quantity), 0);

            return this.registerContext.normalizeDecimalPlaces(newPrice);
        }

        getPackagePriceCharge() {
            if (!this.packageSale) {
                return 0;
            }

            let chargeAmount = this.packageSale.isPackageChargePercent ?
                this.roundingService.multiplyNormalizedNumbers(this.getPackagePriceForChargeCalculation(), this.packageSale.packageChargeAmount) :
                this.packageSale.packageChargeAmount;

            return this.roundingService.addNormalizedNumbers(this.getPackagePrice(), chargeAmount);
        }

        getPackagePriceForChargeCalculation() {
            if (!this.packageHasProducts()) {
                return this.packageSale.price;
            }
            let packageServicePrice = this.getPackageServicePrice();
            let packageProductPrice = this.getPackageProductPrice();
            let totalBasePrice = this.roundingService.addNormalizedNumbers(packageServicePrice, packageProductPrice);
            if (totalBasePrice == 0) {
                return 0;
            }
            let serviceWeight = this.registerContext.normalizeDecimalPlaces(packageServicePrice / totalBasePrice);
            let finalTotalServiceAmountForChargeCalculation = this.roundingService.multiplyNormalizedNumbers(this.packageSale.price, serviceWeight);

            return finalTotalServiceAmountForChargeCalculation;
        }

        clearReferredBy() {
            this.selectedReferredByDetail = {
                id: null,
                displayName: null,
                referredBy: Model.Guard.isNothing(this.selectedReferredByEnum) ? null : this.selectedReferredByEnum
            };
        }

        referredByChanged() {
            if (this.selectedReferredByDetail !== undefined) {
                this.selectedReferredByDetail.referredBy = this.selectedReferredByEnum;
                this.selectedReferredByDetail.referralDisplayName = this.selectedReferredByDetail.displayName;
            }
        }

        showStudentTeacherReferrerAlert(referredBy: Meevo.Model.ReferredByEnum, contentKey : string) : void {
            if (referredBy && !this.canViewStudentTeacherModule) {
                this.modalService.alert(contentKey, Meevo.Components.Modal.ModalTranslationModes.Translate, false, { okButtonContentKey: 'LABEL_OK' });
            }
        }

        // --- REFUND ---

        client: Model.ClientListItem = null;
        transactionSaleLines: any;
        packageNumber: string;
        packageSelected: any;
        applyRefundToUnlimitedPackage: boolean = false;

        request = {
            pageNumber: 0,
            itemsPerPage: 25,
            criteria: {
                isRefunded: false,
                isRemaining: true,
                isExpiredOrRemaining: true,
                isRefundMode: true,
                client_TId: null,
                packageNumber: null,
                includeUnlimitedServices: true,
                includeAuthorizationPaymentRequest: true,
            }
        };

        private onSearch = (pageNumber) => {
            if (this.transactionSaleLines.numItems > 0 && pageNumber === 0) {
                this.setRefundAmounts();
                this.expandSingleResult();
            } else {
                this.packageSelected = null;
            }
        }

        private clearSearch() {
            this.request.criteria.packageNumber = '';
            this.request.criteria.client_TId = '';
        }

        refundClientChange() {
            this.clearSearch();

            if (!this.client) {
                this.packageSelected = null;
                return;
            }

            this.showRefundPackageDetails = false;
            this.request.criteria.packageNumber = '';
            this.request.criteria.client_TId = this.client.id;

            this.transactionSaleLines.initSearch(this.request);
        }

        refundPackageNumberChange() {
            this.clearSearch();

            if (!this.packageNumber || this.packageNumber.trim().length === 0) {
                this.packageSelected = '';
                return;
            }

            this.request.criteria.packageNumber = this.packageNumber;
            this.request.criteria.client_TId = '';

            this.transactionSaleLines.initSearch(this.request);
        }

        getServiceTotal(pkg, service, cb: (serviceItem: any, pkg: any) => number): number {
            return this.getItemTotal(pkg, service, cb, pkg.clientPackageServicesList);
        }

        getProductTotal(pkg, product, cb: (productItem: any, pkg: any) => number): number {
            return this.getItemTotal(pkg, product, cb, pkg.clientPackageProductsList);
        }

        getItemTotal(pkg, item, cb: (pkgItem: any, pkg: any) => number, itemsList = undefined): number {

            itemsList = itemsList || pkg.clientPackageItemsList;

            let items = _.chain(itemsList)
                .filter((packageItem) => packageItem.itemId === item.itemId && !packageItem.isUsed)
                .sortBy((packageItem) => packageItem.linePaidPriceEach)
                .value();

            let max: number = +item.refundQuantity;
            let sum: number = 0;

            for (let i = 0; i < max; i++) {
                sum += +cb(items[i], pkg);
            }

            return this.registerContext.normalizeDecimalPlaces(sum);
        }

        getUnlimitedTotal(filterPkg?: any): number {
            let sum = 0;

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => (filterPkg && filterPkg === pkg) || (!filterPkg && pkg))
                .filter((pkg) => pkg.isUnlimitedServices && pkg.isRefund)
                .each((pkg) => {
                    sum += pkg.unlimitedTotalRemaining;
                })
                .value();

            return this.registerContext.normalizeDecimalPlaces(sum);
        }

        getUnlimitedTax(filterPkg?: any): { baseAmount: number, finalAmount: number } {
            let sum = {
                baseAmount: 0,
                finalAmount: 0,
            };

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => (filterPkg && filterPkg === pkg) || (!filterPkg && pkg))
                .filter((pkg) => pkg.isUnlimitedServices && pkg.isRefund)
                .filter((pkg) => !pkg.isTaxIncludedInPrice)
                .each((pkg) => {
                    let taxes = this.getUnlimitedTaxes(pkg);

                    sum.baseAmount += taxes.reduce((sum, item) => sum + Math.abs(item.baseAmount), 0);
                    sum.finalAmount += taxes.reduce((sum, item) => sum + Math.abs(item.finalAmount), 0);
                })
                .value();

            sum.baseAmount = this.registerContext.normalizeDecimalPlaces(sum.baseAmount);
            sum.finalAmount = this.registerContext.normalizeDecimalPlaces(sum.finalAmount);

            return sum;
        }

        getUnlimitedTaxes(pkg: any) {
            let taxes = [];
            let total = this.getUnlimitedTotal(pkg);
            if (total <= 0) {
                return taxes;
            }

            if (pkg.clientPackageTaxes) {
                for (let unlimitedItemTax of pkg.unlimitedItemTaxes) {
                    let taxEntry = {
                        baseAmount: -Math.abs(unlimitedItemTax.baseAmount),
                        finalAmount: -Math.abs(unlimitedItemTax.finalAmount),
                        taxRate: unlimitedItemTax.taxRate,
                        taxRateId: unlimitedItemTax.taxRateId,
                        taxTypeId: unlimitedItemTax.taxTypeId,
                        taxTypeDisplayName: unlimitedItemTax.taxTypeDisplayName,
                        isIncludedInPrice: unlimitedItemTax.isIncludedInPrice,
                    };

                    taxes.push(taxEntry);
                }
            }

            return taxes;
        }

        getTaxLines(filterPkg) {
            let taxLines = [];

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => filterPkg === pkg)
                .filter((pkg) => !pkg.isUnlimitedServices || this.hasLimitedPackageItems(pkg))
                .filter((pkg) => !pkg.isTaxIncludedInPrice)
                .each((pkg) => {
                    const validPackageItems = pkg.isUnlimitedServices ? pkg.clientPackageItems
                        .filter(item => !_(this.allowedUnlimitedItemTypes).contains(item.itemType)):
                        pkg.clientPackageItems;
                    _.chain(validPackageItems)
                        .filter((item) => item.refundQuantity)
                        .each((item) => {
                            let items = _.chain(pkg.clientPackageItemsList)
                                .filter((listItem) => listItem.itemId === item.itemId && !listItem.isUsed)
                                .sortBy((listItem) => listItem.linePaidPriceEach)
                                .value();

                            let max: number = +item.refundQuantity;

                            for (let i = 0; i < max; i++) {
                                taxLines.push(...items[i].taxes);
                            }
                        });
                });

            return taxLines;
        }

        getUnlimitedCharges(pkg: any) {
            let charges = [];
            let total = this.getUnlimitedTotal(pkg);

            if (pkg.clientPackageCharges) {
                for (let index = 0; index < pkg.clientPackageCharges.length; index++) {
                    let clientPackageCharge = pkg.clientPackageCharges[index];
                    
                    let chargeEntry = {
                        baseAmount: -Math.abs(clientPackageCharge.baseAmount),
                        finalAmount: -Math.abs(clientPackageCharge.finalAmount),
                        chargeType: clientPackageCharge.chargeType,
                        chargeAmount: clientPackageCharge.chargeAmount,
                        isPercent: clientPackageCharge.isPackageChargePercent
                    };

                    charges.push(chargeEntry);
                }
            }

            return charges;
        }

        getUnlimitedCharge(filterPkg?: any): { baseAmount: number, finalAmount: number } {
            let sum = {
                baseAmount: 0,
                finalAmount: 0,
            };

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => (filterPkg && filterPkg === pkg) || (!filterPkg && pkg))
                .filter((pkg) => pkg.isUnlimitedServices && pkg.isRefund)
                .each((pkg) => {
                    let charges = this.getUnlimitedCharges(pkg);

                    sum.baseAmount += charges.reduce((sum, item) => sum + Math.abs(item.baseAmount), 0);
                    sum.finalAmount += charges.reduce((sum, item) => sum + Math.abs(item.finalAmount), 0);
                })
                .value();

            sum.baseAmount = this.registerContext.normalizeDecimalPlaces(sum.baseAmount);
            sum.finalAmount = this.registerContext.normalizeDecimalPlaces(sum.finalAmount);

            return sum;
        }

        getUnlimitedChargeTaxes(pkg: any) {
            let chargeTaxes = [];
            let packageChargeTaxes: any[];
            let total = this.getUnlimitedTotal(pkg);
            if (total <= 0) {
                return chargeTaxes;
            }

            if (pkg.clientPackageCharges) {
                packageChargeTaxes = _(pkg.clientPackageCharges).chain().pluck("taxes").flatten().value();
            }

            for (let index = 0; index < packageChargeTaxes.length; index++) {
                let chargeTax = packageChargeTaxes[index];
                
                let chargeTaxEntry = {
                    baseAmount: -Math.abs(chargeTax.baseAmount),
                    finalAmount: -Math.abs(chargeTax.finalAmount),
                    taxRate: chargeTax.taxRate,
                    taxRateId: chargeTax.taxRateId,
                    taxTypeId: chargeTax.taxTypeId,
                    taxTypeDisplayName: chargeTax.taxTypeDisplayName,
                    isIncludedInPrice: chargeTax.isIncludedInPrice
                };

                chargeTaxes.push(chargeTaxEntry);
            }
            return chargeTaxes;
        }

        getUnlimitedChargeTax(filterPkg?: any): { baseAmount: number, finalAmount: number } {
            let sum = {
                baseAmount: 0,
                finalAmount: 0,
            };

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => (filterPkg && filterPkg === pkg) || (!filterPkg && pkg))
                .filter((pkg) => pkg.isUnlimitedServices && pkg.isRefund)
                .each((pkg) => {
                    let chargeTaxes = this.getUnlimitedChargeTaxes(pkg);

                    sum.baseAmount += chargeTaxes.reduce((sum, item) => sum + Math.abs(item.baseAmount), 0);
                    sum.finalAmount += chargeTaxes.reduce((sum, item) => sum + Math.abs(item.finalAmount), 0);
                })
                .value();

            sum.baseAmount = this.registerContext.normalizeDecimalPlaces(sum.baseAmount);
            sum.finalAmount = this.registerContext.normalizeDecimalPlaces(sum.finalAmount);

            return sum;
        }

        getChargeLines(filterPkg) {
            let chargeLines = [];

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => filterPkg === pkg)
                .filter((pkg) => !pkg.isUnlimitedServices || this.hasLimitedPackageItems(pkg))
                .each((pkg) => {
                    const validClientPackageItems = pkg.isUnlimitedServices ?
                        pkg.clientPackageItems.filter(item => !_(this.allowedUnlimitedItemTypes).contains(item.itemType)) :
                        pkg.clientPackageItems;
                    _.chain(validClientPackageItems)
                        .filter((item) => item.refundQuantity)
                        .each((item) => {
                            let items = _.chain(pkg.clientPackageItemsList)
                                .filter((listItem) => listItem.itemId === item.itemId && !listItem.isUsed)
                                .sortBy((listItem) => listItem.linePaidPriceEach)
                                .value();

                            let max: number = +item.refundQuantity;

                            for (let i = 0; i < max; i++) {
                                chargeLines.push(...items[i].charges);
                            }
                        });
                });
            for (let chargeLine of chargeLines) {
                chargeLine.isPercent = chargeLine.isPackageChargePercent;
            }
            return chargeLines;
        }

        getTotal(cb: (serviceItem: any, pkg: any) => number, filterPkg?: any): number {
            let sum: number = 0;

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => (filterPkg && filterPkg === pkg) || (!filterPkg && pkg))
                .filter((pkg) => !pkg.isUnlimitedServices || this.hasLimitedPackageItems(pkg))
                .each((pkg) => {
                    _.chain(pkg.clientPackageItems)
                        .filter((item) => item.refundQuantity)
                        .each((item) => {
                            sum += this.getItemTotal(pkg, item, cb);
                        });
                });

            return this.registerContext.normalizeDecimalPlaces(sum);
        }

        calculateTotal(pkg?: any) {
            let serviceSubTotal = this.getTotal((serviceItem) => serviceItem.linePaidPriceEach, pkg);
            let unlimitedSubTotal = this.getUnlimitedTotal(pkg);

            let serviceTax = this.getTax(pkg);
            let unlimitedTax = this.getUnlimitedTax(pkg).finalAmount;

            let serviceCharge = this.getCharge(pkg);
            let unlimitedCharge = this.getUnlimitedCharge(pkg).finalAmount;
            let unlimitedChargeTaxes = this.getUnlimitedChargeTax(pkg).finalAmount;

            this.prepaidTipAmount = this.getTotal((serviceItem) => serviceItem.prepaidTip || 0, pkg);

            this.refundSubTotal = this.registerContext.normalizeDecimalPlaces(serviceSubTotal + unlimitedSubTotal +
                serviceCharge + unlimitedCharge);
            this.refundTax = this.registerContext.normalizeDecimalPlaces(serviceTax + unlimitedTax + unlimitedChargeTaxes);

            this.refundTotal = this.registerContext.normalizeDecimalPlaces(this.refundSubTotal + this.refundTax + this.prepaidTipAmount);
        }

        setRefundAmounts() {
            let rows = _(this.transactionSaleLines.loadedPages).flatten();

            _(rows).each((pkg) => {
                if (!pkg) {
                    return;
                }

                let existingSaleLine = _.findWhere(this.registerContext.sale.saleLines,
                    {
                        refundLocationId: pkg.saleLocationId,
                        refundSaleId: pkg.saleId,
                        refundSaleLineId: pkg.saleLineId,
                        refundTransactionId: pkg.saleTransactionId,
                        isRefund: true,
                        saleType: Model.SalesTypeEnum.Package
                    });

                if (existingSaleLine) {
                    let saleLineItem = <Register.PackageSaleLineItem>existingSaleLine.item;

                    var grouped = _(saleLineItem.clientPackage.packageItems).groupBy('itemId');

                    _(pkg.clientPackageItems).each(item => {
                        let match = grouped[item.itemId];
                        item.refundQuantity = match.length;
                    });

                }
            });
        }

        createUnlimitedServicesPackageRefund(pkg) {
            let clientPackage = {
                id: pkg.clientPackage_TId,
                clientPackageNumber: pkg.packageNumber,
                prepaidTip: 0,
                isUnlimitedServices: 1,
            }

            let packageSaleLineItem = new Meevo.Plugins.Register.PackageSaleLineItem({
                id: pkg.clientPackage_TId,
                displayName: pkg.displayName,
            });

            let total = this.getUnlimitedTotal(pkg);

            let tax = this.getUnlimitedTax(pkg);
            let taxes = this.getUnlimitedTaxes(pkg);

            let charge = this.getUnlimitedCharge(pkg);
            let charges = this.getUnlimitedCharges(pkg);

            let chargeTax = this.getUnlimitedChargeTax(pkg);
            let chargeTaxes = this.getUnlimitedChargeTaxes(pkg);
            // Should be at most just the one package charge
            if (charges.length > 0) {
                charges[0].taxes = chargeTaxes;
            }

            packageSaleLineItem.clientPackage = clientPackage;

            const taxAmount = this.roundingService.addNormalizedNumbers(tax.finalAmount, chargeTax.finalAmount);
            let saleItem = this.getSaleLine(pkg, packageSaleLineItem, total, -Math.abs(taxAmount), taxes, charges, 0);

            packageSaleLineItem.unlimitedTotal = this.roundingService.addNormalizedNumbers(saleItem.tax, saleItem.finalPriceCharge);
            saleItem.client = this.client;

            return saleItem;
        }

        getSaleLine(pkg, packageSaleLineItem: PackageSaleLineItem, total: number, tax: number, taxes: any[], charges: any[], prepaidTip: number): Model.SaleLine {
            let saleLine: Model.SaleLine = {
                quantity: 1,
                itemDisplayName: pkg.displayName,
                baseItemPrice: -Math.abs(total),
                basePrice: -Math.abs(total),
                finalItemPrice: -Math.abs(total),
                finalPrice: -Math.abs(total),
                tax: -Math.abs(tax),
                taxes: taxes,
                charges: charges,
                prepaidTip: prepaidTip,
                clientId: null,
                clientType: null,
                saleType: Model.SalesTypeEnum.Package,
                employeeId: pkg.employeeId,
                employeeSplitCommission: pkg.employeeSplitCommission,
                employee: pkg.employee,
                employeeDisplayName: pkg.employee != null ? pkg.employee.displayName : null,
                secondEmployeeId: pkg.secondEmployeeId,
                secondEmployeeSplitCommission: pkg.secondEmployeeSplitCommission,
                secondEmployee: pkg.secondEmployee,
                isRefund: true,
                locationId: pkg.saleLocationId,
                saleDate: pkg.saleDate,
                saleId: pkg.saleId,
                id: pkg.saleLineId,
                transactionId: pkg.saleTransactionId,
                item: packageSaleLineItem,
                priceIncludesTax: pkg.isTaxIncludedInPrice,
                paymentPlanId: pkg.paymentPlanId
            };

            // prevent price flash

            saleLine.baseCharge = _(charges).reduce((sum, charge) => this.roundingService.addNormalizedNumbers(sum, charge.baseAmount), 0);
            saleLine.basePriceCharge = this.roundingService.addNormalizedNumbers(saleLine.basePrice, saleLine.baseCharge);
            saleLine.baseItemCharge = saleLine.baseCharge;
            saleLine.baseItemPriceCharge = saleLine.basePriceCharge;

            saleLine.finalCharge = _(charges).reduce((sum, charge) => this.roundingService.addNormalizedNumbers(sum, charge.finalAmount), 0);
            saleLine.finalPriceCharge = this.roundingService.addNormalizedNumbers(saleLine.finalPrice, saleLine.finalCharge);
            saleLine.finalItemCharge = saleLine.finalCharge;
            saleLine.finalItemPriceCharge = saleLine.finalPriceCharge;

            return saleLine;
        }

        getTax(pkg?: any) {
            if (pkg && pkg.isTaxIncludedInPrice) {
                return 0;
            }

            return this.getTotal(
                (serviceItem, pkg) => {
                    if (pkg.isTaxIncludedInPrice) {
                        return 0;
                    }
                    return _(serviceItem.taxes).reduce((memo, service) => memo + service.finalAmount, 0) +
                        _(serviceItem.charges).chain().pluck("taxes").flatten().
                            reduce((sum, tax) => sum + tax.finalAmount, 0).value();
                },
                pkg
            );
        }

        getCharge(pkg?: any) {
            return this.getTotal(
                (serviceItem, pkg) => _(serviceItem.charges).reduce((memo, service) => memo + service.finalAmount, 0),
                pkg
            );
        }

        createPackageRefund(pkg) {
            let prepaidTip = this.getTotal((serviceItem) => serviceItem.prepaidTip || 0, pkg);
            let total = this.getTotal((serviceItem) => serviceItem.linePaidPriceEach, pkg);
            let tax = this.getTax(pkg);
            let taxes = this.getTaxLines(pkg);
            let charge = this.getCharge(pkg);
            let charges = this.getChargeLines(pkg);

            let clientPackage: any = {
                id: pkg.clientPackage_TId,
                clientPackageNumber: pkg.packageNumber,
                prepaidTip: prepaidTip,
                packageServices: this.getPackageItemsForRefund(pkg, Model.PackageItemTypeEnum.Service),
                packageProducts: this.getPackageItemsForRefund(pkg, Model.PackageItemTypeEnum.Product),
                packageProductUnitsUsed: this.getPackageItemsForRefund(pkg, Model.PackageItemTypeEnum.ProductUnit)
            };

            clientPackage.packageItems = this.getAllPackageItems(clientPackage);

            let packageSaleLineItem = new Meevo.Plugins.Register.PackageSaleLineItem({
                id: pkg.clientPackage_TId,
                displayName: pkg.displayName,
            });

            packageSaleLineItem.clientPackage = clientPackage;

            let saleItem = this.getSaleLine(pkg, packageSaleLineItem, total, -Math.abs(tax), taxes, charges, prepaidTip);

            saleItem.client = this.client;

            return saleItem;
        }

        getPackageItemsForRefund(pkg, itemType: Model.PackageItemTypeEnum) {
            var completeCreation = (listFunc: (item) => any, getAdditionalProperties: (item) => any) =>
                _.chain(pkg.clientPackageItems)
                    .filter(listFunc)
                    .map(listFunc)
                    .flatten()
                    .map((item) => {
                        return {
                            id: item.clientItemId,
                            itemId: item.itemId,
                            clientPackageId: item.clientPackage_TId,
                            displayName: item.displayName,
                            quantity: 1,
                            valueEach: item.lineValuePriceEach,
                            prepaidTip: item.prepaidTip,
                            linePaidPriceEach: item.linePaidPriceEach,
                            itemType: item.itemType,
                            ...getAdditionalProperties(item)
                        };
                    })
                    .value();

            var productFunc = (item): any => {
                return {
                    productVariantId: item.itemId,
                    productVariantDisplayName: item.displayName
                }
            };

            var serviceFunc = (item): any => {
                return {
                    serviceId: item.itemId,
                    serviceDisplayName: item.displayName
                }
            };

            var productUnitFunc = (item): any => {
                return {
                    productVariantId: item.itemId,
                    productVariantDisplayName: item.displayName,
                    prePaidTipUsed: item.prepaidTip,
                    chargeBaseAmountUsed: item.chargeBaseAmountUsed,
                    chargeFinalAmountUsed: item.chargeFinalAmountUsed,
                    paidPriceUsed: item.paidPriceUsed,
                    usageTaxes: item.usageTaxes,
                    redeemQuantity: 1
                }
            };

            switch (itemType) {
                case Model.PackageItemTypeEnum.Product:
                    return completeCreation(item => item.productList, productFunc);
                case Model.PackageItemTypeEnum.ProductUnit:
                    return completeCreation(item => item.productUnitList, productUnitFunc);
                case Model.PackageItemTypeEnum.Service:
                default:
                    return completeCreation(item => item.serviceList, serviceFunc);
            }
        }

        getAllPackageItems(pkg) {
            return [...pkg.packageServices, ...pkg.packageProducts, ...(pkg.packageProductUnits || pkg.packageProductUnitsUsed)];
        }

        applyRefundItems() {
            let refundCount = 0;

            _.chain(this.transactionSaleLines.loadedPages)
                .flatten()
                .filter((pkg) => pkg)
                .each((pkg) => {
                    let unlimitedItemSaleLine: Model.SaleLine;
                    if (pkg.isUnlimitedServices && pkg.isRefund && this.applyRefundToUnlimitedPackage) {
                        unlimitedItemSaleLine = this.createUnlimitedServicesPackageRefund(pkg);
                        refundCount++;
                    }

                    if (!this.hasLimitedPackageItems(pkg)) {
                        this.registerContext.addRefundSaleLine(unlimitedItemSaleLine, Model.SalesTypeEnum.Package);
                        return;
                    }

                    let packageItems = 0;

                    var usedPackageServices = pkg.isUnlimitedServices ? [] : this.getUsedPackageServicesInSale();
                    var usedPackageProducts = this.getUsedPackageProductsInSale();
                    var usedPackageItems = [...usedPackageServices, ...usedPackageProducts];

                    //cleanup from possible previous selections
                    _(pkg.clientPackageServices).each((service) => {
                        service.serviceList = [];
                    });

                    _(pkg.clientPackageProducts).each((product) => {
                        product.productList = [];
                    });

                    const validClientPackageItems = pkg.isUnlimitedServices ?
                        pkg.clientPackageItems.filter(item => !_(this.allowedUnlimitedItemTypes).contains(item.itemType)) :
                        pkg.clientPackageItems;

                    _.chain(validClientPackageItems)
                        .each((item) => {
                            var availableItemsForRefund = _.chain(pkg.clientPackageItemsList)
                                .filter((pkgItem) => {
                                    return pkgItem.itemId === item.itemId
                                        && !pkgItem.isUsed
                                        && (!pkg.isUnlimitedServices || pkgItem.itemType !== Model.PackageItemTypeEnum.Service)
                                        && (usedPackageItems[item.clientPackage_TId] == null
                                            || usedPackageItems[item.clientPackage_TId].length == 0
                                            || _.findWhere(usedPackageItems[item.clientPackage_TId], { id: pkgItem.itemId }) == null);
                                })
                                .sortBy((pkgItem) => pkgItem.linePaidPriceEach)
                                .value();

                            item.refundQuantity = Math.min(item.refundQuantity, availableItemsForRefund.length);

                            switch(item.itemType) {
                                case Model.PackageItemTypeEnum.Product:
                                    item.productList = _.take(availableItemsForRefund, item.refundQuantity);
                                    break;
                                case Model.PackageItemTypeEnum.ProductUnit:
                                    item.productUnitList = _.take(availableItemsForRefund, item.refundQuantity);
                                    break;
                                case Model.PackageItemTypeEnum.Service:
                                default:
                                    item.serviceList = _.take(availableItemsForRefund, item.refundQuantity);
                            }

                            packageItems += item.refundQuantity;
                        });

                    let saleLine: Model.SaleLine;
                    if (packageItems > 0) {
                        saleLine = this.createPackageRefund(pkg);
                        refundCount++;
                    }

                    this.mergeUnlimitedAndLimitedSaleLineForRefund(saleLine, unlimitedItemSaleLine);
                    this.registerContext.addRefundSaleLine(saleLine || unlimitedItemSaleLine, Model.SalesTypeEnum.Package);
                })
                .value();

            if (refundCount > 0) {
                this.registerContext.recalculateSale();
            }
        }

        mergeUnlimitedAndLimitedSaleLineForRefund(limitedSaleLine: Model.SaleLine, unlimitedItemSaleLine: Model.SaleLine) {
            if (!limitedSaleLine || !unlimitedItemSaleLine) {
                return;
            }

            limitedSaleLine.baseItemPrice = this.roundingService.addNormalizedNumbers(limitedSaleLine.baseItemPrice, unlimitedItemSaleLine.baseItemPrice);
            limitedSaleLine.basePrice = this.roundingService.addNormalizedNumbers(limitedSaleLine.basePrice, unlimitedItemSaleLine.basePrice);
            limitedSaleLine.finalItemPrice = this.roundingService.addNormalizedNumbers(limitedSaleLine.finalItemPrice, unlimitedItemSaleLine.finalItemPrice);
            limitedSaleLine.finalPrice = this.roundingService.addNormalizedNumbers(limitedSaleLine.finalPrice, unlimitedItemSaleLine.finalPrice);
            limitedSaleLine.tax = this.roundingService.addNormalizedNumbers(limitedSaleLine.tax, unlimitedItemSaleLine.tax ? unlimitedItemSaleLine.tax : 0);
            limitedSaleLine.taxes = unlimitedItemSaleLine.taxes ?
                [...limitedSaleLine.taxes, ...unlimitedItemSaleLine.taxes] :
                limitedSaleLine.taxes;
            limitedSaleLine.charges = unlimitedItemSaleLine.charges ?
                [...limitedSaleLine.charges, ...unlimitedItemSaleLine.charges] :
                limitedSaleLine.charges;
            (limitedSaleLine.item as Model.PackageSaleLineItem).clientPackage.isUnlimitedServices = true;
            (limitedSaleLine.item as Model.PackageSaleLineItem).unlimitedTotal = (unlimitedItemSaleLine.item as Model.PackageSaleLineItem).unlimitedTotal;
            (limitedSaleLine.item as Model.PackageSaleLineItem).clientPackage.prepaidTip = 0;
        }

        refundQuantityChange(packageItem) {
            if (packageItem.refundQuantity < 0) {
                packageItem.refundQuantity = 0;
            }

            if (packageItem.refundQuantity > packageItem.quantityRemaining) {
                this.modalService.alert("MESSAGE_REFUND_QUANTITY_EXCEED_VALIDATION");
                packageItem.refundQuantity = packageItem.quantityRemaining;
            }

            this.calculateTotal();
        }

        refundPackageSelected(packageSelected) {
            if (this.registerContext.isMismatch(this.registerContext.getAuthorizationPaymentRequestId(this.registerContext.sale), packageSelected.authorizationPaymentRequestId)) {
                this.registerContext.displayRefundMismatchMessage(false, true);
                return;
            }

            let rows = _(this.transactionSaleLines.loadedPages).flatten();
            this.applyRefundToUnlimitedPackage = false;

            _(rows).each((item) => {
                item.active = false;
            });

            var usedPackageItems = [...this.getUsedPackageServicesInSale(), ...this.getUsedPackageProductsInSale()];

            this.packageSelected = packageSelected;

            packageSelected.active = true;

            if (packageSelected.isUnlimitedServices) {
                packageSelected.isRefund = true;
                this.showRefundPackageDetails = true;
            }

            if (this.hasLimitedPackageItems(packageSelected)) {
                _(packageSelected.clientPackageItems).each((item) => {
                    if (!item.refundQuantity) {
                        item.refundQuantity = 0;
                    }
                    if (!item.originalQuantityRemaining) {
                        item.originalQuantityRemaining = item.quantityRemaining;
                    }
                    var usedPackage: any[] = usedPackageItems[item.clientPackage_TId];
                    if (usedPackage) {
                        item.quantityRemaining = Math.max(item.originalQuantityRemaining - usedPackage.length, 0);
                    }
                    //if (this.isUnlimitedServicesWithZeroPrice(packageSelected)) {
                    if (packageSelected.isUnlimitedServices) {
                        item.refundQuantity = item.quantityRemaining;
                    }
                });

                this.showRefundPackageDetails = true;
            }
            this.calculateTotal(packageSelected);

        }

        getLimitedPackageItems(pkg) {
            if (!pkg.isUnlimitedServices) {
                return pkg.clientPackageItems;
            }
            return pkg.clientPackageItems
                .filter(item => this.allowedUnlimitedItemTypes.indexOf(item.itemType) === -1);
        }

        hasLimitedPackageItems(pkg) {
            return this.getLimitedPackageItems(pkg).length > 0;
        }

        isUnlimitedServiceItem(pkg, item) {
            return pkg.isUnlimitedServices && !_(pkg.clientPackageProducts).any((productItem) => productItem.itemId == item.itemId);
        }

        getUsedPackageItemsInSale(clientPackageItemUsed: string, packageItem: string): any[] {
            if (this.registerContext.sale.saleLines.length < 1) {
                return [];
            }

            var usedPackageItems: any[] = _.chain(this.registerContext.sale.saleLines)
                .filter((sl: Model.SaleLine) => { return (sl.saleType === Model.SalesTypeEnum.Service && sl.packageRedeemed); })
                .pluck("packageRedemptionPath")
                .pluck(clientPackageItemUsed)
                .flatten(true)
                .pluck(packageItem)
                .groupBy("clientPackageId")
                .value();

            // get transferred package service(s) in sale, if any
            _.chain(this.registerContext.sale.saleLines)
                .filter((sl: Model.SaleLine) => { return sl.saleType === Model.SalesTypeEnum.PackageTransfer })
                .pluck("item")
                .pluck("clientPackage")
                .pluck(`${packageItem}s`)
                .flatten(true)
                .each((ps: any) => {
                    if (usedPackageItems[ps.donorClientPackageId] == null) {
                        usedPackageItems[ps.donorClientPackageId] = [];
                    }
                    usedPackageItems[ps.donorClientPackageId].push({ id: ps.donorClientPackageItemId });
                });

            usedPackageItems = usedPackageItems.length && usedPackageItems.length > 0 ?
                usedPackageItems :
                [];

            return usedPackageItems;
        }

        getUsedPackageServicesInSale(): any[] {
            return this.getUsedPackageItemsInSale(this.clientPackageServiceUsed, this.packageService);
        }

        getUsedPackageProductsInSale(): any[] {
            return this.getUsedPackageItemsInSale(this.clientPackageProductUsed, this.packageProduct);
        }

        refundTransaction() {
            this.registerContext.getSaleLinesToRefundFromTransactionId(this.scannedTransactionId).then(() => { this.scannedTransactionId = ""; });
        }

        getPackageDisplayName(packageItem) {
            if (!packageItem) {
                return null;
            }

            if (packageItem.packageCreationType === Meevo.Model.PackageCreationTypeEnum.Custom) {
                return this.$translate.instant("LABEL_CUSTOM_PACKAGE");
            }

            return packageItem.displayName;
        }

        getPackagePriceEach(service) {
            if (!service) {
                return 0;
            }

            let price = service.linePaidPriceEach;

            if (service.charges) {
                for (let i = 0; i < service.charges.length; i++) {
                    price += service.charges[i].finalAmount;
                }
            }

            return this.roundingService.normalizeDecimalPlaces(price);
        }

        getPurchasedByName(packageItem) {
            if (!packageItem) {
                return null;
            }

            switch (packageItem.purchasedByClientType) {
                case Meevo.Model.ClientTypeEnum.AnonymousMale:
                    return this.$translate.instant("LABEL_ANONYMOUS_MALE");
                case Meevo.Model.ClientTypeEnum.AnonymousFemale:
                    return this.$translate.instant("LABEL_ANONYMOUS_FEMALE");
                case Meevo.Model.ClientTypeEnum.AnonymousOther:
                    return this.$translate.instant("LABEL_ANONYMOUS_OTHER");
                default:
                    return packageItem.purchasedByDisplayName;
            }
        }

        canApplyRefund(): boolean {
            if (this.packageSelected && this.packageSelected.isUnlimitedServices && !this.applyRefundToUnlimitedPackage) {
                return false;
            }
            return true;
        }

        // --- END REFUND ---

        isShareableDisabled(): boolean {
            return !this.isCustomPackage() ||
                this.packageSale.isMembershipOnly ||
                this.packageSale.isUnlimitedServices ||
                this.isProductUsageTrackingPackage();
        }

        isUnlimitedServicesDisabled(): boolean {
            return !this.isCustomPackage() ||
                (!this.packageSale.isUnlimitedServices && this.packageSale.isSplitSwapable) ||
                this.packageSale.isFullCommissionRedemption ||
                this.packageSale.isShareable ||
                this.packageSale.packageServices.length < 1 ||
                this.isPredefinedPackage();
        }

        isSplitSwapableDisabled(): boolean {
            return this.packageSale.isUnlimitedServices || !this.isCustomPackage() || !this.packageHasServices();
        }

        isUnlimitedSwapableDisabled(): boolean {
            return !this.isCustomPackage() || !this.packageHasServices();
        }

        isUnlimitedSwapableVisible(): boolean {
            return this.packageSale.isUnlimitedServices;
        }

        isFullCommissionRedemptionDisabled(): boolean {
            return !this.isCustomPackage() || this.packageSale.isUnlimitedServices;
        }

        isPackageChargeDisabled() {
            return !this.isCustomPackage() || this.packageSale.isMembershipOnly ||
                (!this.packageHasServices() && !this.packageHasProductUnits());
        }

        packageHasServices() {
            return this.packageSale.packageServices && this.packageSale.packageServices.length > 0;
        }

        packageHasProducts() {
            return this.packageSale.packageProducts && this.packageSale.packageProducts.length > 0;
        }

        packageHasProductUnits() {
            return this.packageSale.packageProductUnits && this.packageSale.packageProductUnits.length > 0;
        }

        packageHasMinimumItems(minimum: number = 1) {
            return ((this.packageSale.packageServices || []).length + (this.packageSale.packageProducts || []).length + (this.packageSale.packageProductUnits || []).length) >= minimum;
        }

        customPackageHasMinimumItems(minimum: number = 1) {
            return this.isCustomPackage() && this.packageHasMinimumItems(minimum);
        }

        expandSingleResult() {
            if (this.transactionSaleLines && this.transactionSaleLines.loadedPages.length === 1 &&
                this.transactionSaleLines.loadedPages[0].length === 1) {

                    this.refundPackageSelected(this.transactionSaleLines.loadedPages[0][0]);
            }
        }

        get decimalRoundingDigits(): number {
            const identity = this.registerContext.identityService.current();
            const digits = identity.decimalPositions;
            return digits;
        }
    }
}